import PropTypes from 'prop-types';

import {planPropTypes} from '../../utils/propTypes';

import Details from './Details';
import Header from './Header';

function Plan(props) {
  return (
    <div
      className={`col-sm-10 col-md-6 col-xl-4 p-3${props.plan.recommended ? '' : ' pt-5'}`}
    >
      <div
        data-id={`plan-${props.plan.externalId}`}
        className={`box ${props.plan.recommended ? 'emphasis pt-5' : 'shadow'}`}
      >
        <Header
          plan={props.plan}
          currentPlan={props.currentPlan}
          onPlanSelection={props.onPlanSelection}
        />
        <hr className="my-4"/>
        <Details
          plan={props.plan}
          maxDefaultFeatures={props.maxDefaultFeatures}
          onPlanSelection={props.onPlanSelection}
        />
      </div>
    </div>
  );
}

Plan.propTypes = {
  plan: planPropTypes().isRequired,
  maxDefaultFeatures: PropTypes.number.isRequired,
  onPlanSelection: PropTypes.func.isRequired,
  currentPlan: planPropTypes()
};

export default Plan;
